//use by: sesarch-layout & toolbar-layout
var alleyWidthByBreakPoint = [
    "502px",
    "502px",
    "502px",
    "502px",
    "600px",
    "625px",
    "640px", //xxxl
];
var stickyFilterAlleyWidth = ["340px"];
export { alleyWidthByBreakPoint, stickyFilterAlleyWidth };
//# sourceMappingURL=styles.js.map